<!-- i am in need of a refactor! -->

<template>
	<div class="button custom-radio"
		 :class="{
			'selected': selected,
			'icon-present': options.icon,
			'tick-present': !circleSelect
		}"
		 @click="toggle"
		 @keyup.enter="toggle">
		<!--
			TODO: removed the keyup space 07/11/2024 to fix issue with space not selecting inputs (as it
			was firing twice). Remove these comments during code clean up if its confirmed to not affect
			anything else
			@keyup.space="toggleSelected"
			- Samson
		-->
		<input class="radio"
			   :type="asCheckbox ? 'checkbox' : 'radio'"
			   :name="name || uuid"
			   :value="options.text"
			   :disabled="disabled"
			   :checked="selected"
			   :id="options.text">
		<img v-if="options.icon"
			 :src="options.icon"
			 :alt="options.altText"
			 class="icon">
		<div v-if="circleSelect"
			 :class="{
				'circle-present': circleSelect,
				'selected': selected
			}" />
		<label :for="options.text" class="visually-hidden">
			{{ options.text }}
		</label>
		{{ options.text }}

		<p v-if="options.description"
		   class="text description"
		   v-html="options.description" />
	</div>
</template>

<script>
import { createUUID } from '~/lib/utils';

	export default {
		props: {
			options: {
				type: Object,
				default: function () {
					return {};
				},
			},
			disabled: Boolean,
			selectedOption: {
				type: Object,
				default: function () {
					return {};
				},
			},
			circleSelect: {
				type: Boolean,
				default: false,
			},
			name: String,
			asCheckbox: Boolean
		},
		emits: ['selected'],
		data() {
			return {
				selected: false,
				uuid: createUUID()
			};
		},
		computed: {
			inheritedSelected() {
				return this.selectedOption.selected;
			}
		},
		watch: {
			inheritedSelected: function () {
				this.selected = this.inheritedSelected;
			},
			selectedOption: function () {
				if (this.selectedOption.text !== this.options.text && this.selected) {
					this.selected = !this.selectedOption.selected;
				}
			}
		},
		mounted() {
			if (this.selectedOption.text === this.options.text) {
				this.selected = this.selectedOption.selected;
			}
		},
		methods: {
			toggle() {
				if (this.disabled) {
					return;
				}

				this.selected = !this.selected;

				// this is not ideal ↓
				this.$emit('selected', {
					text: this.options.text,
					selected: this.selected,
					type: this.options?.type,
					icon: this.options?.icon,
				});
			}
		},
	};
</script>

<style scoped lang="scss">

	// TODO: Refactor these so its in .SCSS files

	$inactive: #d9dadc;
	$text-color: #40474f;
	$border-color: #d9dadc;
	$wesleyan-green: #193941;
	$wesleyan-yellow: #FFFF97;

	input {
		appearance: none;
		opacity: 0;
		position: absolute;
		clip: rect(0 0 0 0);
		width: 1px;
		height: 1px;
		overflow: hidden;
	}

	.tick-present {
		&.selected::after {
			content: '';
			background-image: url('data:image/svg+xml;charset=utf-8,<svg fill="none" width="15" height="15" viewBox="-2 -3 16 16" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6762 0.774975C10.9449 0.446619 11.419 0.406667 11.7352 0.685738C12.0271 0.943343 12.0823 1.38273 11.8777 1.70707L11.8212 1.78558L4.09608 11.225C3.8089 11.5759 3.29997 11.5895 2.99481 11.2742L2.93269 11.2016L0.160453 7.30812C-0.0958217 6.9692 -0.0390179 6.4787 0.287328 6.21255C0.588569 5.96688 1.01418 5.99824 1.27944 6.27109L1.34225 6.34431L3.54625 9.48614L10.6762 0.774975Z" fill="#FFFF97"/> </svg>');
			background-position: center;
			background-repeat: no-repeat;
			background-size: 14px;
			display: block;
			position: absolute;
			top: -10px;
			right: -10px;
			background-color: $wesleyan-green;
			height: 24px;
			width: 24px;
			border-radius: 25px;
		}
	}

	.circle-present {
		width: 15px;
		height: 15px;
		border: 2px solid $inactive;
		border-radius: 25px;
		color: $text-color;
		margin-top: 12px;
		display: inline-block;
		float: left;
		top: 50px;
		background-color: white;
		transition: all 0.2s;

		&.selected {
			color: $wesleyan-green;
			background-color: $wesleyan-green;
			border: 2px solid white;
			outline: $wesleyan-green;
			outline-width: 2px;
			outline-style: solid;
		}
	}

	.description {
		font-weight: 400;
		font-size: 12px;
	}
</style>
